import React, { useState } from 'react';
import { Users, Calendar, BarChart2, Clock, Plus, Save } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Modal } from '../ui/Modal';
import { useToast } from '../../context/ToastContext';
export function TeamView() {
  const navigate = useNavigate();
  const {
    showToast
  } = useToast();
  const [viewMode, setViewMode] = useState('calendar');
  const [isAddEmployeeModalOpen, setIsAddEmployeeModalOpen] = useState(false);
  // Form state
  const [newEmployee, setNewEmployee] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    position: '',
    department: '',
    startDate: ''
  });
  // Mock data
  const teamMembers = [{
    id: 1,
    name: 'Marie Dupont',
    position: 'Développeuse Frontend',
    avatar: 'MD',
    status: 'present'
  }, {
    id: 2,
    name: 'Jean Martin',
    position: 'Product Manager',
    avatar: 'JM',
    status: 'leave',
    leaveInfo: "Congés jusqu'au 15 nov."
  }, {
    id: 3,
    name: 'Sophie Bernard',
    position: 'Designer UX',
    avatar: 'SB',
    status: 'present'
  }, {
    id: 4,
    name: 'Thomas Petit',
    position: 'Développeur Backend',
    avatar: 'TP',
    status: 'onboarding',
    startDate: '1 nov. 2023'
  }, {
    id: 5,
    name: 'Camille Roux',
    position: 'Designer UX',
    avatar: 'CR',
    status: 'present'
  }];
  // Calendar data (simplified)
  const days = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven'];
  const teamCalendar = [{
    id: 1,
    name: 'Marie Dupont',
    avatar: 'MD',
    absences: [false, false, false, false, false]
  }, {
    id: 2,
    name: 'Jean Martin',
    avatar: 'JM',
    absences: [true, true, true, true, true]
  }, {
    id: 3,
    name: 'Sophie Bernard',
    avatar: 'SB',
    absences: [false, false, true, false, false]
  }, {
    id: 4,
    name: 'Thomas Petit',
    avatar: 'TP',
    absences: [false, false, false, false, false]
  }, {
    id: 5,
    name: 'Camille Roux',
    avatar: 'CR',
    absences: [false, false, true, true, false]
  }];
  const handleEmployeeClick = (employeeId: number) => {
    navigate(`/manager/employee/${employeeId}`);
  };
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewEmployee({
      ...newEmployee,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmitNewEmployee = () => {
    // Validation simple
    if (!newEmployee.firstName || !newEmployee.lastName || !newEmployee.email) {
      showToast('Veuillez remplir tous les champs obligatoires', 'error');
      return;
    }
    // En production, ceci ferait un appel API
    console.log('Nouvel employé:', newEmployee);
    showToast(`${newEmployee.firstName} ${newEmployee.lastName} a été ajouté à l'équipe`, 'success');
    // Reset form
    setNewEmployee({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      position: '',
      department: '',
      startDate: ''
    });
    setIsAddEmployeeModalOpen(false);
  };
  return <div data-id="element-1654">
      <div className="mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-1655">
        <div data-id="element-1656">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-1657">Mon équipe</h1>
          <p className="text-gray-600" data-id="element-1658">Gérez et suivez votre équipe</p>
        </div>
        <button onClick={() => setIsAddEmployeeModalOpen(true)} className="flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 shadow-sm hover:shadow-md transition-all" data-id="element-1659">
          <Plus className="h-5 w-5" data-id="element-1660" />
          Ajouter un employé
        </button>
      </div>

      <div className="bg-white rounded-lg shadow-sm p-6 mb-6" data-id="element-1661">
        <div className="flex justify-between items-center mb-6" data-id="element-1662">
          <h2 className="text-lg font-semibold text-gray-900" data-id="element-1663">
            Vue d'ensemble
          </h2>
          <div className="flex space-x-2" data-id="element-1664">
            <button onClick={() => setViewMode('list')} className={`px-3 py-1 rounded text-sm ${viewMode === 'list' ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-1665">
              <Users className="h-4 w-4 inline mr-1" data-id="element-1666" />
              Liste
            </button>
            <button onClick={() => setViewMode('calendar')} className={`px-3 py-1 rounded text-sm ${viewMode === 'calendar' ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-1667">
              <Calendar className="h-4 w-4 inline mr-1" data-id="element-1668" />
              Calendrier
            </button>
          </div>
        </div>

        {viewMode === 'list' ? <div className="space-y-4" data-id="element-1669">
            {teamMembers.map(member => <div key={member.id} className="border border-gray-200 rounded-lg p-4 hover:border-blue-300 hover:shadow-sm transition-all" data-id="element-1670">
                <div className="flex items-center justify-between" data-id="element-1671">
                  <div className="flex items-center" data-id="element-1672">
                    <div className={`h-10 w-10 rounded-full ${member.status === 'present' ? 'bg-green-100 text-green-800' : member.status === 'leave' ? 'bg-amber-100 text-amber-800' : 'bg-blue-100 text-blue-800'} flex items-center justify-center font-medium`} data-id="element-1673">
                      {member.avatar}
                    </div>
                    <div className="ml-3" data-id="element-1674">
                      <button onClick={() => handleEmployeeClick(member.id)} className="font-medium text-gray-900 hover:text-blue-600 text-left" data-id="element-1675">
                        {member.name}
                      </button>
                      <p className="text-sm text-gray-600" data-id="element-1676">{member.position}</p>
                    </div>
                  </div>
                  <div className="flex items-center" data-id="element-1677">
                    {member.status === 'present' ? <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs" data-id="element-1678">
                        Présent
                      </span> : member.status === 'leave' ? <span className="flex items-center px-2 py-1 bg-amber-100 text-amber-800 rounded-full text-xs" data-id="element-1679">
                        <Clock className="h-3 w-3 mr-1" data-id="element-1680" />
                        {member.leaveInfo}
                      </span> : <span className="px-2 py-1 bg-blue-100 text-blue-800 rounded-full text-xs" data-id="element-1681">
                        Onboarding depuis {member.startDate}
                      </span>}
                  </div>
                </div>
                <div className="mt-4 flex space-x-2 justify-end" data-id="element-1682">
                  <button onClick={() => handleEmployeeClick(member.id)} className="px-3 py-1 border border-gray-300 rounded text-sm text-gray-700 hover:bg-gray-50" data-id="element-1683">
                    Voir la fiche
                  </button>
                  <button className="px-3 py-1 border border-gray-300 rounded text-sm text-gray-700 hover:bg-gray-50" data-id="element-1684">
                    1:1
                  </button>
                  <button className="px-3 py-1 bg-blue-600 text-white rounded text-sm hover:bg-blue-700" data-id="element-1685">
                    Évaluation
                  </button>
                </div>
              </div>)}
          </div> : <div data-id="element-1686">
            <div className="mb-4 flex justify-between items-center" data-id="element-1687">
              <h3 className="font-medium text-gray-900" data-id="element-1688">
                Calendrier des absences
              </h3>
              <div className="text-sm text-gray-600" data-id="element-1689">
                Semaine du 13 au 17 novembre 2023
              </div>
            </div>
            <div className="overflow-x-auto" data-id="element-1690">
              <table className="min-w-full" data-id="element-1691">
                <thead data-id="element-1692">
                  <tr data-id="element-1693">
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-1694">
                      Employé
                    </th>
                    {days.map((day, index) => <th key={index} className="px-4 py-2 text-center text-xs font-medium text-gray-500 uppercase" data-id="element-1695">
                        {day}
                      </th>)}
                  </tr>
                </thead>
                <tbody data-id="element-1696">
                  {teamCalendar.map(member => <tr key={member.id} className="hover:bg-gray-50" data-id="element-1697">
                      <td className="px-4 py-3 whitespace-nowrap" data-id="element-1698">
                        <div className="flex items-center" data-id="element-1699">
                          <div className="h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-800 font-medium text-sm" data-id="element-1700">
                            {member.avatar}
                          </div>
                          <button onClick={() => handleEmployeeClick(member.id)} className="ml-3 text-sm text-gray-900 hover:text-blue-600" data-id="element-1701">
                            {member.name}
                          </button>
                        </div>
                      </td>
                      {member.absences.map((isAbsent, index) => <td key={index} className="px-4 py-3 text-center" data-id="element-1702">
                          {isAbsent ? <div className="h-6 w-6 bg-red-100 rounded-md mx-auto" data-id="element-1703"></div> : null}
                        </td>)}
                    </tr>)}
                </tbody>
              </table>
            </div>
            <div className="mt-4 flex justify-end" data-id="element-1704">
              <button className="px-3 py-1 border border-gray-300 rounded text-sm text-gray-700 hover:bg-gray-50" data-id="element-1705">
                Voir mois complet
              </button>
            </div>
          </div>}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1706">
        <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-1707">
          <div className="flex items-center justify-between mb-4" data-id="element-1708">
            <h2 className="text-lg font-semibold text-gray-900" data-id="element-1709">
              Performance d'équipe
            </h2>
            <BarChart2 className="h-5 w-5 text-blue-600" data-id="element-1710" />
          </div>
          <div className="space-y-4" data-id="element-1711">
            <div data-id="element-1712">
              <div className="flex justify-between mb-1" data-id="element-1713">
                <span className="text-sm font-medium text-gray-700" data-id="element-1714">
                  1:1 tenus ce mois
                </span>
                <span className="text-sm font-medium text-gray-700" data-id="element-1715">80%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-1716">
                <div className="bg-blue-600 h-2.5 rounded-full" style={{
                width: '80%'
              }} data-id="element-1717"></div>
              </div>
            </div>
            <div data-id="element-1718">
              <div className="flex justify-between mb-1" data-id="element-1719">
                <span className="text-sm font-medium text-gray-700" data-id="element-1720">
                  Objectifs alignés
                </span>
                <span className="text-sm font-medium text-gray-700" data-id="element-1721">75%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-1722">
                <div className="bg-green-500 h-2.5 rounded-full" style={{
                width: '75%'
              }} data-id="element-1723"></div>
              </div>
            </div>
            <div data-id="element-1724">
              <div className="flex justify-between mb-1" data-id="element-1725">
                <span className="text-sm font-medium text-gray-700" data-id="element-1726">
                  Feedback partagés
                </span>
                <span className="text-sm font-medium text-gray-700" data-id="element-1727">
                  1.2/mois
                </span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-1728">
                <div className="bg-purple-500 h-2.5 rounded-full" style={{
                width: '60%'
              }} data-id="element-1729"></div>
              </div>
            </div>
          </div>
          <button className="mt-4 w-full py-2 px-4 border border-blue-600 text-blue-600 hover:bg-blue-50 rounded-md text-sm font-medium transition-colors duration-150 ease-in-out" data-id="element-1730">
            Voir rapport détaillé
          </button>
        </div>

        <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-1731">
          <div className="flex items-center justify-between mb-4" data-id="element-1732">
            <h2 className="text-lg font-semibold text-gray-900" data-id="element-1733">
              Prochains 1:1
            </h2>
            <Calendar className="h-5 w-5 text-blue-600" data-id="element-1734" />
          </div>
          <div className="space-y-3" data-id="element-1735">
            <div className="border-l-4 border-blue-500 pl-3 py-2" data-id="element-1736">
              <div className="flex justify-between items-start" data-id="element-1737">
                <div data-id="element-1738">
                  <button onClick={() => handleEmployeeClick(1)} className="font-medium text-gray-900 hover:text-blue-600" data-id="element-1739">
                    1:1 avec Marie Dupont
                  </button>
                  <div className="flex items-center text-sm text-gray-600 mt-1" data-id="element-1740">
                    <Calendar className="h-4 w-4 mr-1" data-id="element-1741" />
                    <span data-id="element-1742">15 nov. 2023, 14:00</span>
                  </div>
                </div>
                <button onClick={() => navigate('/performance')} className="text-xs px-2 py-1 bg-blue-100 text-blue-800 rounded-full hover:bg-blue-200 transition-colors" data-id="element-1743">
                  Préparer
                </button>
              </div>
            </div>
            <div className="border-l-4 border-blue-500 pl-3 py-2" data-id="element-1744">
              <div className="flex justify-between items-start" data-id="element-1745">
                <div data-id="element-1746">
                  <button onClick={() => handleEmployeeClick(3)} className="font-medium text-gray-900 hover:text-blue-600" data-id="element-1747">
                    1:1 avec Sophie Bernard
                  </button>
                  <div className="flex items-center text-sm text-gray-600 mt-1" data-id="element-1748">
                    <Calendar className="h-4 w-4 mr-1" data-id="element-1749" />
                    <span data-id="element-1750">17 nov. 2023, 10:00</span>
                  </div>
                </div>
                <button onClick={() => navigate('/performance')} className="text-xs px-2 py-1 bg-blue-100 text-blue-800 rounded-full hover:bg-blue-200 transition-colors" data-id="element-1751">
                  Préparer
                </button>
              </div>
            </div>
            <div className="border-l-4 border-blue-500 pl-3 py-2" data-id="element-1752">
              <div className="flex justify-between items-start" data-id="element-1753">
                <div data-id="element-1754">
                  <button onClick={() => handleEmployeeClick(4)} className="font-medium text-gray-900 hover:text-blue-600" data-id="element-1755">
                    1:1 avec Thomas Petit
                  </button>
                  <div className="flex items-center text-sm text-gray-600 mt-1" data-id="element-1756">
                    <Calendar className="h-4 w-4 mr-1" data-id="element-1757" />
                    <span data-id="element-1758">20 nov. 2023, 15:30</span>
                  </div>
                </div>
                <button onClick={() => navigate('/performance')} className="text-xs px-2 py-1 bg-blue-100 text-blue-800 rounded-full hover:bg-blue-200 transition-colors" data-id="element-1759">
                  Préparer
                </button>
              </div>
            </div>
          </div>
          <button className="mt-4 w-full py-2 px-4 border border-blue-600 text-blue-600 hover:bg-blue-50 rounded-md text-sm font-medium transition-colors duration-150 ease-in-out" data-id="element-1760">
            Voir calendrier complet
          </button>
        </div>
      </div>

      {/* Modal d'ajout d'employé */}
      <Modal isOpen={isAddEmployeeModalOpen} onClose={() => setIsAddEmployeeModalOpen(false)} title="Ajouter un nouvel employé" size="lg" data-id="element-1761">
        <div className="space-y-4" data-id="element-1762">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1763">
            <div data-id="element-1764">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1765">
                Prénom <span className="text-red-500" data-id="element-1766">*</span>
              </label>
              <input type="text" name="firstName" value={newEmployee.firstName} onChange={handleInputChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Ex: Marie" data-id="element-1767" />
            </div>
            <div data-id="element-1768">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1769">
                Nom <span className="text-red-500" data-id="element-1770">*</span>
              </label>
              <input type="text" name="lastName" value={newEmployee.lastName} onChange={handleInputChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Ex: Dupont" data-id="element-1771" />
            </div>
          </div>

          <div data-id="element-1772">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1773">
              Courriel <span className="text-red-500" data-id="element-1774">*</span>
            </label>
            <input type="email" name="email" value={newEmployee.email} onChange={handleInputChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Ex: marie.dupont@construction-gauthier.com" data-id="element-1775" />
          </div>

          <div data-id="element-1776">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1777">
              Téléphone
            </label>
            <input type="tel" name="phone" value={newEmployee.phone} onChange={handleInputChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Ex: (514) 555-0123" data-id="element-1778" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1779">
            <div data-id="element-1780">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1781">
                Poste
              </label>
              <input type="text" name="position" value={newEmployee.position} onChange={handleInputChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Ex: Développeuse Frontend" data-id="element-1782" />
            </div>
            <div data-id="element-1783">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1784">
                Département
              </label>
              <input type="text" name="department" value={newEmployee.department} onChange={handleInputChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Ex: Technologie" data-id="element-1785" />
            </div>
          </div>

          <div data-id="element-1786">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1787">
              Date de début
            </label>
            <input type="date" name="startDate" value={newEmployee.startDate} onChange={handleInputChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-1788" />
          </div>

          <div className="flex flex-col-reverse sm:flex-row justify-end gap-3 pt-4 border-t" data-id="element-1789">
            <button onClick={() => setIsAddEmployeeModalOpen(false)} className="w-full sm:w-auto px-6 py-2.5 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1790">
              Annuler
            </button>
            <button onClick={handleSubmitNewEmployee} className="w-full sm:w-auto flex items-center justify-center gap-2 px-6 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm font-medium shadow-sm transition-colors" data-id="element-1791">
              <Save className="h-4 w-4" data-id="element-1792" />
              Ajouter l'employé
            </button>
          </div>
        </div>
      </Modal>
    </div>;
}